import React from 'react';

const useToggle = (initialState: boolean) => {
  const [value, setValue] = React.useState(initialState);
  const toggle = React.useCallback(() => setValue((prev) => !prev), []);
  return [value, toggle] as const;
};

export default useToggle;
